import * as types from 'modules/checklists/actionTypes';
import type {
  FetchChecklistAdviceHistoryAction,
  FetchChecklistAdviceHistorySuccessAction,
} from 'modules/checklists/types';
import type { DetailedChecklistAdviceHistory } from 'modules/checklists/types/projections/detailed-checklist-advice-history';
import { createReducer } from 'utils/ReduxUtils';

export type ChecklistAdviceHistoryReducer = {
  [checklistId: string]: {
    [adviceId: string]: {
      loading: boolean;
      data?: DetailedChecklistAdviceHistory[];
    };
  };
};

const INITIAL_VALUE: ChecklistAdviceHistoryReducer = {};

const beforeFetch = (
  state: ChecklistAdviceHistoryReducer,
  { payload }: FetchChecklistAdviceHistoryAction
): ChecklistAdviceHistoryReducer => {
  const { checklistId, adviceId } = payload;
  return {
    ...state,
    [checklistId]: {
      ...state[checklistId],
      [adviceId]: {
        ...state[checklistId]?.[adviceId],
        loading: true,
      },
    },
  };
};

const updateSlice = (
  state: ChecklistAdviceHistoryReducer,
  { payload }: FetchChecklistAdviceHistorySuccessAction
): ChecklistAdviceHistoryReducer => {
  const { content, adviceId, checklistId } = payload;

  return {
    ...state,
    [checklistId]: {
      ...state[checklistId],
      [adviceId]: {
        ...state[checklistId]?.[adviceId],
        loading: false,
        data: content,
      },
    },
  };
};

export default createReducer(INITIAL_VALUE, {
  [types.FETCH_CHECKLIST_ADVICE_HISTORY]: beforeFetch,
  [types.FETCH_CHECKLIST_ADVICE_HISTORY_SUCCESS]: updateSlice,
});
